import { decodeJwtPayload } from '@/lib/auth/jwt'
import { getSessionTokenPayload } from '@/utils/auth'

const idOf = (payload: Record<string, unknown> | null) =>
  typeof payload?.user_id === 'string' && payload.user_id
    ? payload.user_id
    : undefined

/** The account a token was issued to (`user_id` claim of shared/jwt). */
export function userIdFromToken(token?: string): string | undefined {
  return idOf(decodeJwtPayload(token))
}

/** True when the token is gone or expires within `marginMs`. */
export function tokenExpiresWithin(token: string, marginMs: number): boolean {
  const exp = decodeJwtPayload(token)?.exp
  return typeof exp !== 'number' || exp * 1000 - Date.now() <= marginMs
}

/**
 * The account of the session held in the cookies right now. The cookies are
 * shared by every tab, so this changes under a tab when another one logs out
 * or into another account.
 */
export function readSessionUserId(): string | undefined {
  return idOf(getSessionTokenPayload())
}
